import React, { FC } from 'react';
import { AccordionEventKey } from 'react-bootstrap/AccordionContext';
import { Accordion } from 'react-bootstrap';
import CertifierForm from '../forms/certifier-form';
import { useDispatch, useSelector } from 'react-redux';
import { EducationHistoryModel, EmployeeCertifierModel } from '../../../../shared/models/employee.model';
import { handleEmployeeSectionAddNewData } from '../../../../shared/utils/function-state';
import SectionAddRow from '../section-add-row';
import {
    getCurrentEmployee,
    getCurrentEmployeeEditProfile,
    getEmployeeAction
} from '../../../../shared/services/employee-service';

interface EmployeeCertifierProps {
    defaultKey?: AccordionEventKey;
}

const EmployeeCertifier: FC<EmployeeCertifierProps> = ({defaultKey = '0'}) => {
    const dispatch = useDispatch();
    const employee = useSelector(getCurrentEmployee);
    const employeeAction = useSelector(getEmployeeAction);

    const employeeEditProfile = useSelector(getCurrentEmployeeEditProfile);
    const haveSomeEditField = () => {
        if (employeeAction.type === 'view-edit-request') {
            const lengthNotSame = employee.employee_certifiers.length !== employeeEditProfile.employee_certifiers.length;

            if (lengthNotSame)
                return true;

            return employee.employee_certifiers.some((data, index) => {
                return Object.keys(data).some(key => {
                    const kk = key as keyof EmployeeCertifierModel;
                    if (key === 'id' || key === 'employee_id' || key === 'created_at'  || key === 'updated_at' || key === 'from_id')
                        return false;
                    return employeeEditProfile.employee_certifiers[index][kk] !== data[kk];
                });
            });
        }
        return false;
    };

    const onAddNewData = () => {
        const initData: EmployeeCertifierModel = {
            id: null,
            employee_id: null,
            name: null,
            relationship: null,
            position: null,
            file: null,
            new_file: true,
            file_name: '',
            from_id: null,
        };
        handleEmployeeSectionAddNewData('employee_certifiers', initData, dispatch);
    };
    return (
        <Accordion defaultActiveKey={defaultKey} className="mt-3">
            <Accordion.Item eventKey="0">
                <Accordion.Header className={`text-mof-primary ${haveSomeEditField() ? 'accordion-warning' : ''}`}>
                    <h5 className="text-mof-primary m-0">ผู้รับรองการเข้าทำงาน</h5>
                </Accordion.Header>
                <Accordion.Body>
                    <CertifierForm/>
                    <SectionAddRow onAddNewData={onAddNewData}/>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default EmployeeCertifier;